import FormType from "../../../../../../Components/Form/FormType";
import Url from "../../../../../../Services/Url";

const TermDefinitionFormOptions = (init) => {
	const contract = init?.contract || {};
	const paymentTerm = init?.paymentTerm || {};
	const { contractTerms = {}, contractSign } = contract;
	const disabled = !!contractSign; // Disable if contractSign exists

	return {
		Fields: [
			{
				element: FormType.Select,
				required: true,
				label: "Contract Period (Months)",
				placeholder: "Select contract period",
				options: { url: Url.options.periods, id: "id", name: "name" },
				value: contractTerms?.contractPeriod,
				name: "contractPeriod",
				disabled: disabled,
			},
			{
				element: FormType.Select,
				required: true,
				label: "Warranty Period (Months)",
				placeholder: "Select Warranty Period",
				options: { url: Url.options.periods, id: "id", name: "name" },
				name: "warrantyPeriod",
				value: contractTerms?.warrantyPeriod,
				disabled: disabled,
			},
			{
				element: FormType.Select,
				required: true,
				label: "Payment Term",
				placeholder: "Select Payment Term",
				options: { url: Url.paymentTerms.periods, id: "id", name: "name" },
				name: "paymentTerm",
				value: paymentTerm?.paymentTerm?.id, // Assuming you want to disable based on the PaymentTerm object existing
			},
		],
	};
};

export default TermDefinitionFormOptions;
